<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  options: {
    type: Object, // as PropType<string[]>,
    required: true,
  },
  error: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: "Error",
  },
});

const emit = defineEmits(["select"]);
const model = ref(props.value);
</script>

<template>
  <select
    v-model="model"
    @change="($evt) => emit('select', ($evt.target! as HTMLSelectElement).value)"
  >
    <option value="" selected disabled hidden>Country of Residence *</option>
    <option v-for="option in options" :key="option" :value="option">
      {{ option }}
    </option>
  </select>
  <FormsFieldError v-show="error">{{ errorMessage }}</FormsFieldError>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/forms";
select {
  @include forms.form-select;
}
</style>
